// src/utils/networkTokens.js
export const NETWORK_TOKENS = {
  solana: {
    // Mainnet tokens
    mainnet: {
      SOL: { 
        decimals: 9,
        name: "Solana"
      },
      USDC: { 
        decimals: 6,
        name: "USD Coin",
        mintAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
      },
      USDT: {
        decimals: 6,
        name: "Tether USD", 
        mintAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
      },
      BONK: {
        decimals: 5,
        name: "Bonk",
        mintAddress: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263"
      }
    },
    // Devnet tokens
    devnet: {
      SOL: { 
        decimals: 9,
        name: "Solana"
      },
      USDC: { 
        decimals: 6,
        name: "USD Coin",
        mintAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU"
      },
      USDP: {
        decimals: 9,
        name: "USDP",
        mintAddress: "EuzmVLB9nRownYyDTmhy5LVqc4NxtKyWAXpuc4vGsv49"

      }
    }
  },
  // Adding BSC tokens
  bsc: {
    mainnet: {
      BNB: {
        name: "Binance Coin",
        symbol: "BNB",
        decimals: 18,
        // Native coin doesn't need contract address
      },
      BUSD: {
        name: "Binance USD",
        decimals: 18,
        contractAddress: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"
      },
      USDT: {
        name: "Tether USD",
        decimals: 18,
        contractAddress: "0x55d398326f99059fF775485246999027B3197955"
      }
    },
    testnet: {
      BNB: {
        name: "Binance Coin (Testnet)",
        symbol: "BNB",
        decimals: 18,
      },
      USDP: {
        name: "USDP (Testnet)",
        decimals: 6,
        contractAddress: "0x142dba341134411bf1d89a757ffb18648b02bc07"
      }
    }
  },
  // Adding Base network tokens
  base: {
    mainnet: {
      ETH: {
        name: "Ethereum",
        symbol: "ETH",
        decimals: 18,
        // Native coin doesn't need contract address
      },
      USDC: {
        name: "USD Coin",
        decimals: 6,
        contractAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
      },
      DAI: {
        name: "Dai Stablecoin",
        decimals: 18,
        contractAddress: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb"
      }
    },
    sepolia: {
      ETH: {
        name: "Ethereum (Sepolia)",
        symbol: "ETH",
        decimals: 18,
      },
      USDC: {
        name: "USD Coin (Sepolia)",
        decimals: 6,
        contractAddress: "0x036CbD53842c5426634e7929541eC2318f3dCF7e"
      },
      USDP: {
        name: "USDP",
        decimals: 6,
        contractAddress: "0xac90bf4484551D0A8De4d4C32cbc29841b4d13DC"
      }
    }
  }
};

// Chain IDs for EVM chains
export const CHAIN_IDS = {
  bsc: {
    mainnet: 56,
    testnet: 97
  },
  base: {
    mainnet: 8453,
    sepolia: 84532
  }
  // Add other EVM chains as needed
};

// RPC URLs - could also be moved to env vars
export const RPC_URLS = {
  bsc: {
    mainnet: 'https://bsc-dataseed.binance.org/',
    testnet: 'https://data-seed-prebsc-1-s1.binance.org:8545/'
  },
  base: {
    mainnet: 'https://mainnet.base.org',
    sepolia: 'https://sepolia.base.org'
  }
};

// Block explorers
export const BLOCK_EXPLORERS = {
  bsc: {
    mainnet: 'https://bscscan.com/tx/',
    testnet: 'https://testnet.bscscan.com/tx/'
  },
  base: {
    mainnet: 'https://basescan.org/tx/',
    sepolia: 'https://sepolia.basescan.org/tx/'
  }
};

// Helper function to get token info
export const getTokenInfo = (network, environment, symbol) => {
  try {
    return NETWORK_TOKENS[network][environment][symbol];
  } catch (error) {
    console.error(`Token info not found for ${network}/${environment}/${symbol}`);
    return null;
  }
};

// Helper to get chain ID
export const getChainId = (network, environment) => {
  try {
    return CHAIN_IDS[network][environment];
  } catch (error) {
    console.error(`Chain ID not found for ${network}/${environment}`);
    return null;
  }
};